import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { BroadcastMessage } from 'src/app/models/broadcast-message.model';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';

@Component({
    selector: 'app-safety-and-prevention',
    templateUrl: './safety-and-prevention.component.html',
    styleUrl: './safety-and-prevention.component.scss',
    standalone: false
})
export class SafetyAndPreventionComponent implements OnInit {
  pagepath: 'Home' | 'TrainingProviders' | 'Learners' | 'Employers' = 'Home';
  currentLang: string;
  TPUtil = TrainingProgramApplicationUtils;
  broadcastMessages:BroadcastMessage[]
  displayBroadcastMessages:string[]
  constructor(public translateService: TranslateService, public router: Router, 
    public route: ActivatedRoute, private recaptchaV3Service: ReCaptchaV3Service, 
    public sanitizer: DomSanitizer,
    @Inject('UtilsService') public utilService: UtilsService
  ) {
    this.currentLang = translateService.currentLang;
    translateService.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang
      this.createDisplayMessages()
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if(!this.router || !this.router.url) this.pagepath = 'Home';
      let url = this.router.url.toLowerCase();
      if (url.endsWith('/safety-and-prevention/training-providers')) this.pagepath = 'TrainingProviders';
      else if (url.endsWith('/safety-and-prevention/learners')) this.pagepath = 'Learners';
      else if (url.endsWith('/safety-and-prevention/employers')) this.pagepath = 'Employers';
      else this.pagepath = 'Home';
    });

    
    //Get Broadcast Message
    const curTime = (new Date()).toISOString();
    this.utilService.GetBroadcastMessages({DisplayOnPublic:true, DisplayOnLearner:false, DisplayOnMinistry:false, DisplayOnTp:false, CurrentTime: curTime}).subscribe(res => {
      this.broadcastMessages = res;
      this.createDisplayMessages()
    });

  }

  createDisplayMessages():void{
    this.displayBroadcastMessages = [];
    this.broadcastMessages.forEach(message =>{
      let displayMessage = this.currentLang == 'en' ? `<strong>${message.TitleEn}</strong><br>${message.ContentEn}` : `<strong>${message.TitleFr}</strong><br>${message.ContentFr}`
      this.displayBroadcastMessages.push(displayMessage)
    })
  }

  getUrl(url: string) { return this.currentLang == 'en' ? url : '/fr' + url; }

  getHtml(texto: string): SafeHtml { return this.sanitizer.bypassSecurityTrustHtml(texto); }

  goToLogin(currentUserType: string, currentTimeStr: string = '') {
    //set sessionStorage var to mark that we want to login
    sessionStorage.setItem('reload', 'true')
    const currentTime = currentTimeStr ?? new Date().toISOString()
    let url='';
    switch (currentUserType) {
      case TrainingProgramApplicationUtils.UserTypeLearner:
        url = "../../worker/learner-ftu-enrol";
        this.router.navigate([url], { relativeTo: this.route });
        break;
      case TrainingProgramApplicationUtils.UserTypeEmployer: 
        url = "../../registration/employer";
        this.router.navigate([url], { queryParams: { refresh: `time_${currentTime}` }, relativeTo: this.route });
        break;
      case TrainingProgramApplicationUtils.UserTypeTrainingProvider:
      default: 
        url =  "../../training-provider/register-as-training-provider";
        this.router.navigate([url], { queryParams: { refresh: `time_${currentTime}`, isFromRegistration: true }, relativeTo: this.route });
        break;
    }
   
  }
}
